module.exports = __webpack_public_path__ + "static/media/info.49b1a839.svg";